<template>
  <div
    class="lang-select-container j-card-select-container"
    @mouseleave="hideLangSelecter"
    @click.stop
  >
    <div
      class="lang-item j-select-lang-item"
      :pointValue="langVal"
      :class="{ active: langVal == curLang }"
      @click="selectLang(langVal)"
      v-for="(text, langVal) in langList"
      :key="langVal"
    >
      {{ text }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'LangSelecter',
  props: ['langList', 'curLang'],
  methods: {
    selectLang(langVal) {
      this.$emit('selectLang', langVal);
    },
    hideLangSelecter() {
      this.$emit('hideLangSelecter');
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.lang-select-container {
  position: absolute;
  top: 80px;
  right: 0;
  width: 300px;
  max-height: calc(90vh - 100px);
  box-sizing: border-box;
  border-radius: 10px;
  z-index: 1001;
  padding: 15px;
  background-color: rgba(51, 51, 51, 0.95);
  overflow-y: scroll;

  .lang-item {
    display: flex;
    align-self: center;
    box-sizing: border-box;
    border-radius: 10px;
    width: 100%;
    line-height: 20px;
    padding: 20px 15px;
    font-size: 24px;
    color: #ffffff;
    cursor: pointer;
    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
    &.active {
      background-color: #ffffff;
      color: #333333;
    }
  }
}
#ssr-page.landscape {
  .lang-select-container {
    left: unset;
    transform: unset !important;
    right: 0;
    top: 66px;
    padding: 20px;
    .lang-item {
      padding: 15px;
      font-size: 16px;
    }
  }
}
</style>
